export const lineClamp = (lines: number = 1) => `
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
`;
